"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-label.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "label";
var useComboboxLabel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useComboboxLabel2({ store, ...props }) {
    const context = _EV33XSIBcjs.useComboboxProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "ComboboxLabel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const comboboxId = _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => {
      var _a;
      return (_a = state.baseElement) == null ? void 0 : _a.id;
    });
    props = {
      htmlFor: comboboxId,
      ...props
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var ComboboxLabel = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxLabel2(props) {
    const htmlProps = useComboboxLabel(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.ComboboxLabel = ComboboxLabel; exports.useComboboxLabel = useComboboxLabel;
